const adminRouter = [
  {
    title: '首页',
    type: 'view',
    name: 'dashboard',
    route: '/dashboard',
    filePath: 'view/dashboard/index.vue',
    inNav: true,
    icon: 'iconfont icon-iconset0103',
    isElementIcon: false,
    order: 1,
  },
  {
    route: '/admin/seller',
    name: null,
    title: '商户管理',
    type: 'folder',
    icon: 'iconfont icon-yunyingguanli_fuwufenzuguanli',
    isElementIcon: false,
    filePath: 'view/admin/seller/',
    inNav: true,
    order: 2,
    children: [
      {
        title: '商户列表',
        type: 'view',
        name: 'sellerList',
        route: '/admin/seller/list',
        filePath: 'view/admin/seller/list.vue',
        inNav: true,
        icon: 'iconfont icon-huiyuanguanli',
        isElementIcon: false,
      },
      {
        title: '坐席管理',
        type: 'view',
        name: 'sellerKefu',
        route: '/admin/seller/kefu',
        filePath: 'view/admin/seller/kefu.vue',
        inNav: true,
        icon: 'iconfont icon-huiyuan',
        isElementIcon: false,
      },
      {
        title: '商户配置',
        type: 'view',
        name: 'emojiManage',
        route: '/admin/validate/emoji',
        filePath: 'view/admin/validate/emoji.vue',
        inNav: true,
        icon: 'iconfont icon-zidingyi',
        isElementIcon: false,
      },
      {
        title: '添加商户',
        type: 'view',
        name: 'sellerCreate',
        route: '/admin/seller/create',
        filePath: 'view/admin/seller/create.vue',
        inNav: false,
        icon: 'iconfont icon-add',
        isElementIcon: false,
      },
      {
        title: '编辑商户',
        type: 'view',
        name: 'sellerEdit',
        route: '/admin/seller/edit/:id',
        filePath: 'view/admin/seller/edit.vue',
        inNav: false,
        icon: 'iconfont icon-tianjia',
        isElementIcon: false,
      },
    ],
  },
  {
    route: '/admin/manager',
    name: null,
    title: '管理员',
    type: 'folder',
    icon: 'iconfont icon-huiyuanguanli',
    isElementIcon: false,
    filePath: 'view/admin/manager/',
    inNav: true,
    order: 3,
    children: [
      {
        title: '管理员列表',
        type: 'view',
        name: 'managerList',
        route: '/admin/manager/list',
        filePath: 'view/admin/manager/list.vue',
        inNav: true,
        icon: 'iconfont icon-huiyuanguanli',
        isElementIcon: false,
      },
      {
        title: '添加管理员',
        type: 'view',
        name: 'managerCreate',
        route: '/admin/manager/create',
        filePath: 'view/admin/manager/create.vue',
        inNav: false,
        icon: 'iconfont icon-add',
        isElementIcon: false,
      },
      {
        title: '编辑管理员',
        type: 'view',
        name: 'managerEdit',
        route: '/admin/manager/edit/:id',
        filePath: 'view/admin/manager/edit.vue',
        inNav: false,
        icon: 'iconfont icon-tianjia',
        isElementIcon: false,
      },
    ],
  },
  {
    route: '/admin/dashboard',
    name: null,
    title: '数据大屏',
    type: 'folder',
    icon: 'iconfont icon-iconset0103',
    isElementIcon: false,
    filePath: 'view/admin/dashboard/',
    inNav: true,
    order: 4,
    children: [
      {
        title: '访客大屏',
        type: 'view',
        name: 'visitorDashboard',
        route: '/admin/dashboard/visitorTop',
        filePath: 'view/admin/dashboard/visitor.vue',
        inNav: true,
        icon: 'iconfont icon-iconset0103',
        isElementIcon: false,
      },
      {
        title: '商户大屏',
        type: 'view',
        name: 'sellerDashboard',
        route: '/admin/dashboard/seller',
        filePath: 'view/admin/dashboard/seller.vue',
        inNav: true,
        icon: 'iconfont icon-iconset0103',
        isElementIcon: false,
      },
    ],
  },
  {
    route: '/admin/notice',
    name: null,
    title: '公告管理',
    type: 'folder',
    icon: 'iconfont icon-pinglun',
    isElementIcon: false,
    filePath: 'view/admin/notice/',
    inNav: true,
    order: 5,
    children: [
      {
        title: '公告列表',
        type: 'view',
        name: 'noticeList',
        route: '/admin/notice/list',
        filePath: 'view/admin/notice/list.vue',
        inNav: true,
        icon: 'iconfont icon-pinglun',
        isElementIcon: false,
      },
    ],
  },
  {
    route: '/admin/system',
    name: null,
    title: '系统管理',
    type: 'folder',
    icon: 'iconfont icon-zidingyi',
    isElementIcon: false,
    filePath: 'view/admin/system/',
    inNav: true,
    order: 6,
    children: [
      {
        title: '配置信息',
        type: 'view',
        name: 'systemConfig',
        route: '/admin/system/index',
        filePath: 'view/admin/system/index.vue',
        inNav: true,
        icon: 'iconfont icon-zidingyi',
        isElementIcon: false,
      },
      {
        title: '操作日志',
        type: 'view',
        name: 'operateLog',
        route: '/admin/log/operate',
        filePath: 'view/admin/log/operate.vue',
        inNav: true,
        icon: 'iconfont icon-rizhiguanli',
        isElementIcon: false,
      },
      {
        title: '登录日志',
        type: 'view',
        name: 'loginLog',
        route: '/admin/log/login',
        filePath: 'view/admin/log/login.vue',
        inNav: true,
        icon: 'iconfont icon-rizhiguanli',
        isElementIcon: false,
      },
      {
        title: 'IP黑名单',
        type: 'view',
        name: 'ipBlacklist',
        route: '/admin/system/ip-blacklist',
        filePath: 'view/admin/system/ip-blacklist.vue',
        inNav: true,
        icon: 'iconfont icon-zidingyi',
        isElementIcon: false,
      },
    ],
  },
  // 以下菜单不在主导航中显示，但路由仍可用
  {
    route: '/admin/word',
    name: null,
    title: '违禁词管理',
    type: 'folder',
    icon: 'iconfont icon-shanchu',
    isElementIcon: false,
    filePath: 'view/admin/word/',
    inNav: false,
    order: 7,
    children: [
      {
        title: '违禁词列表',
        type: 'view',
        name: 'wordList',
        route: '/admin/word/list',
        filePath: 'view/admin/word/list.vue',
        inNav: true,
        icon: 'iconfont icon-shanchu',
        isElementIcon: false,
      },
      {
        title: '违禁词触发列表',
        type: 'view',
        name: 'forbiddenList',
        route: '/admin/word/forbidden-list',
        filePath: 'view/admin/word/forbidden-list.vue',
        inNav: true,
        icon: 'iconfont icon-shanchu',
        isElementIcon: false,
      },
    ],
  },
  {

    route: '/admin/chat',
    name: null,
    title: '聊天日志管理',
    type: 'folder',
    icon: 'iconfont icon-pinglun',
    isElementIcon: false,
    filePath: 'view/admin/chat/',
    inNav: false,
    order: 9,
    children: [
      {
        title: '聊天日志列表',
        type: 'view',
        name: 'chatList',
        route: '/admin/chat/list',
        filePath: 'view/admin/chat/list.vue',
        inNav: true,
        icon: 'iconfont icon-pinglun',
        isElementIcon: false,
      },
    ],
  },
  {
    title: '修改密码',
    type: 'view',
    name: 'password',
    route: '/admin/password',
    filePath: 'view/admin/password.vue',
    inNav: false,
    icon: 'iconfont icon-quan',
    isElementIcon: false,
    order: 10,
  },
]

export default adminRouter
